<div class="chips-tags-container">
    <aa-chips-tag-item [tag]="tag"
                       *ngFor="let tag of tags"
                       (detachTagEvent)="onDetachTagEvent(tag.tagId)"
                       (tagClickEvent)="onTagClickEvent(tag)"
                       [isFiltrable]="isFiltrable">
    </aa-chips-tag-item>
    <aa-chips-tag-input [tags]="tags"
                        (attachTagEvent)="onAttachTagEvent($event)">
    </aa-chips-tag-input>
</div>
